module.exports = __webpack_public_path__ + "static/media/quickspin.9c474a53.png";